import demo1 from "../img/demo1.png";
import demo2 from "../img/demo2.png";

const images = (function () {
  return {
    demo1,
    demo2,
  };
})();

export { images };
